module.exports = __webpack_public_path__ + "static/media/ZKTeco_Gray-Green.c9648589.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ZKTeco_Gray-Green.png
// module id = 1260
// module chunks = 0